import React from 'react'
import styled from 'styled-components'
import logo from '../images/logo.png';
import {dashboardTabs} from "../data/DashboardTabs"
import "./Styles/Fonts.css"

const Sidebar = ({setTabs}) => {
    return (
        <SidebarContainer>
           <LogoContainer>
              <Avatar src={logo}/>
           </LogoContainer>
           <TabsContainer>
              {dashboardTabs.map((item, i) => (
                <TabsBtn type="button" key={i} onClick={() => {
                    setTabs(item.title)
                    }} >
                {item.title}
                </TabsBtn>
              ))}
           </TabsContainer>
            
        </SidebarContainer>
    )
}

export default Sidebar
const SidebarContainer = styled.div`
height: 100vh;
width: 200px;
z-index: 10;
background-color: #00022C;
position: fixed;
display: flex;
flex-direction: column;
align-items: center;
`
const Avatar = styled.img`
color: #000;
display: flex;
align-items: center;
padding: 0 1rem;
height: 100%;
cursor: pointer;
`
const LogoContainer = styled.div`
height: 80px;
margin-top: 15px;
`
const TabsContainer = styled.div`
margin-top: 150px;
display: flex;
flex-direction: column;
align-items: flex-start;
justify-content: center;
`
const TabsBtn = styled.button`
margin: 2px 12px;
font-size: clamp(0.5rem, 3vw, 1.2rem);
font-family: Gilroy-Medium;
padding: 5px 18px;
border-radius: 5px;
outline: none;
border: none;
color: #fff;
background-color: transparent;
cursor: pointer;
&:hover{
    background-color: #4C52EA;
    color: #fff;
}
&:active, :focus{
    background-color: #4C52EA;
    color: #fff;
    font-size: 20px;
}

`